<template>
    <div><ams-base-chart :chartTitle="chartTitle" :chartType="ChartTypes.BAR" :data="chartData" :showLegend="false" /></div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { ChartTypes } from '../../../../../../enums';
import { Colors } from '../../../../../../utilities/colors';
const props = defineProps({
    jsonData: {
        type: Array,
    },
    type: {
        type: String,
    },
});

const chartData = ref([]);

onMounted(() => {
    loadChartData();
});

const chartTitle = computed(() => {
    return `Incident Type ${props.type}`;
});

const loadChartData = () => {
    // console.log('Loading Data for Learning Call Sign by Appliances', props.jsonData);
    chartData.value = props.jsonData?.map((data) => {
        return {
            label: data.name,
            values: [
                {
                    value: data.tot,
                    bgcolor: Colors.BLUE,
                },
            ],
        };
    });
};
</script>
